(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["josef-chat-launcher"] && !Shopify.designMode) return;
  try {
    (() => {
  const launcher = document.querySelector('.oj-chat-launcher');
  if (!launcher) return;
  function connect() {
    const chat = document.querySelector('shopify-chat');
    if (!chat || !customElements.get('shopify-chat')) return false;
    const sync = () => { launcher.hidden = chat.hasAttribute('open'); };
    launcher.addEventListener('click', event => {
      event.preventDefault();
      chat.setAttribute('mode', 'standalone');
      chat.setAttribute('open', '');
      sync();
    });
    new MutationObserver(sync).observe(chat, { attributes: true, attributeFilter: ['open'] });
    document.documentElement.classList.add('oj-custom-chat-ready');
    sync();
    return true;
  }
  customElements.whenDefined('shopify-chat').then(() => {
    if (connect()) return;
    const observer = new MutationObserver(() => { if (connect()) observer.disconnect(); });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 15000);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["josef-inbox-link"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('josef-inbox-link')) {
  customElements.define('josef-inbox-link', class extends HTMLElement {
    static pending = false;
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('click', async event => {
        const trigger = event.target.closest('[data-question],[data-open-inbox]');
        if (!trigger || !this.contains(trigger)) return;
        event.preventDefault();
        if (this.constructor.pending) return;
        const status = this.querySelector('[role="status"]');
        const chat = document.querySelector('shopify-chat');
        const question = trigger.dataset.question;
        status.hidden = false;
        if (!chat || (question && typeof chat.sendStarterMessage !== 'function')) {
          status.textContent = this.dataset.error;
          if (chat) { chat.setAttribute('mode', 'standalone'); chat.setAttribute('open', ''); }
          return;
        }
        this.constructor.pending = true;
        const buttons = document.querySelectorAll('josef-inbox-link button');
        buttons.forEach(button => { button.disabled = true; });
        trigger.setAttribute('aria-busy', 'true');
        try {
          chat.setAttribute('mode', 'standalone');
          if (question) {
            status.textContent = this.dataset.sending;
            await chat.sendStarterMessage(question, 'suggestion_pill');
            status.textContent = this.dataset.sent;
          } else {
            chat.setAttribute('open', '');
            status.hidden = true;
          }
        } catch {
          status.textContent = this.dataset.error;
        } finally {
          this.constructor.pending = false;
          buttons.forEach(button => { button.disabled = false; });
          trigger.removeAttribute('aria-busy');
        }
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
